<script>
import { Button } from "element-ui";

export default {
    functional: true,
    name: "tq-button",
    render: function(createElement, context) {
        return createElement(Button, context.data, context.children);
    },
};
</script>

<style scoped lang="scss">
@import "../../../../scss/basic/_button";
@import "element-ui/packages/theme-chalk/src/button";

.el-button {
    box-shadow: $--tq-button-box-shadow;
    font-family: inherit;
    text-transform: capitalize;
    border-radius: 4px;
    letter-spacing: 0.4px;
    font-weight: 600;
    line-height: 20px;
    font-size: 16px;
    padding: 8px 16px;
    ::v-deep span {
        display: inline-block;
    }
    &--small {
        font-size: 14px;
        line-height: 1;
    }
    &.primary-gradient {
        background: linear-gradient(90deg, #2d9cdb -16.75%, #1461d2 99.9%);
        border: none;
    }
    &.secondary-gradient {
        background: linear-gradient(94.66deg, #ff512f 3.77%, #f09819 96.23%);
        border: none;
    }
    &.btn-icon {
        border: 1px solid #d8dce6;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        ::v-deep span {
            display: flex;
            align-items: center;
            padding: 0;
            .text {
                margin-left: 16px;
                font-weight: 500;
                font-size: 14px;
                line-height: 14px;
            }
        }
    }
    &.text-red {
        color: red;
    }
    &.text-primary {
        color: #1665d8;
    }
}
</style>
